import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {AfterViewInit, Component, effect, ElementRef, input, Input, OnDestroy, viewChild, ViewChild, ViewEncapsulation} from "@angular/core";
import {NgStyle} from "@angular/common";
import type {ChartAPI, ChartConfiguration} from "c3";
import {generate} from "c3";
import {erNil} from "felles-ng2/støttefunksjoner/nilsjekk";

const debug = initDebugger('C3GrafKomponent');


/** Viser en graf vhja biblioteket 'c3', se https://c3js.org */
@Component({
    selector: 'c3-graf',
    template: '<div [ngStyle]="{width: bredde(), height: hoeyde()}" #kontainer></div>',
    styleUrl: 'c3-graf.scss',
    host: {
        'role': 'figure',
        '[attr.aria-label]': 'ariaLabel()',
        '[attr.aria-labelledby]': 'ariaLabelledBy()'
    },
    imports: [NgStyle],
})
export class C3GrafKomponent implements AfterViewInit, OnDestroy {

    kontainer = viewChild.required<ElementRef<HTMLElement>>('kontainer');

    /** C3 konfigurasjon, se https://c3js.org/reference.html */
    konfigurasjon = input<ChartConfiguration | null>(null);
    bredde = input('300px');
    hoeyde = input('300px');
    ariaLabel = input<string | null>(null);
    ariaLabelledBy = input<string | null>(null);

    private c3Diagram: ChartAPI | null = null;

    constructor() {
        effect(() => {
            if (erNil(this.konfigurasjon())) return;
            this.tegnGraf();
        });
    }

    ngAfterViewInit() {
        //nå er this.kontainer tilgjengelig
        this.tegnGraf();
    }

    ngOnDestroy(): void {
        this.terminerGraf();
    }

    private tegnGraf() {
        if (erNil(this.kontainer()?.nativeElement)) return;
        if (erNil(this.konfigurasjon())) return;

        const c3Konfigurasjon: ChartConfiguration = {
            ...this.konfigurasjon()!,
            bindto: this.kontainer().nativeElement,
        };

        debug('tegnGraf, med konfig', c3Konfigurasjon)
        this.terminerGraf();
        this.c3Diagram = generate(c3Konfigurasjon);
    }

    private terminerGraf() {
        if (erNil(this.c3Diagram)) return;
        this.c3Diagram.destroy();
    }
}

